<template>
    <div id="ChatWrapper">
        <div id="ChatHistory">
            <ChatEntry v-for="message in Messages" :key="message" :Message="message" :MessageID="message.msgID" :OnFeedback="FeedbackCallback" />
            <PendingEntry v-if="IsResponding" />
        </div>
    </div>
</template>

<script>
import ChatEntry from './ChatEntry.vue';
import PendingEntry from './PendingEntry.vue';

export default{
    components:{
        ChatEntry,
        PendingEntry,
    },
    props:{
        Messages: Array,
        IsResponding: Boolean,
        FeedbackCallback: Function,
    }
}
</script>

<style>
#ChatWrapper
{
    overflow-y: auto;
    flex: 1;
    padding-bottom: 30px;
    padding-right: 20px;
}

#ChatHistory
{
    background-color: #ddd;
    padding: 10px;
    min-height: 300px;
    overflow-y: auto;
    border-radius: 10px;
}

</style>